export default __webpack_public_path__ + "static/media/WateringFlowers.e1425993.svg";